/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  formatFecha,
  Sidebar, tituloBase, TablaFiltrable } from "../../../../shared";

const SEARCH_FIELDS = ["titulo"];

export default function Eulas() {
  const [loader, setLoader] = useState(true);
  const [eulas, setEulas] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearEula(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/eula",
      camposFormulario,
      (respuesta) => {
        navigate(`/eula/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear el acuerdo",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del acuerdo",
        campos: [
          {
            nombre: "titulo",
            tipoitemformularioid: 1,
            etiqueta: "Título",
            requerido: true
          },
          {
            nombre: "texto",
            tipoitemformularioid: 11,
            etiqueta: "Texto",
            requerido: true
          }
        ]
      }
    ],
    botones: [{ etiqueta: "Crear acuerdo", callback: crearEula, validar: true }]
  };

  useEffect(() => {
    document.title = "Acuerdos de servicio";
    accessAPI(
      "GET",
      "admin/eula",
      null,
      (respuesta) => {
        setEulas(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar los acuerdos",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo acuerdo de servicio</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="16rem" height="2.5rem" />
          </div>
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>Nuevo acuerdo</Boton>
            }
          >
            Acuerdos de servicio
          </Titulo>

          <Card>
            <TablaFiltrable
              value={eulas}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="eulas"
              emptyMessage="No hay acuerdos de servicio registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/eula/${e.data.id}`, "_blank");
                } else {
                  navigate(`/eula/${e.data.id}`);
                }
              }}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Título" field="titulo" />
              <Column
                header="Estado"
                body={(rowData) => (
                  <Tag
                    severity={rowData.generado ? "success" : "warning"}
                    css={{ fontSize: "0.75rem" }}
                  >
                    {rowData.generado ? "Generado" : "Borrador"}
                  </Tag>
                )}
                style={{ width: "8rem", textAlign: "center" }}
              />
              <Column
                header="Fecha de generación"
                body={(rowData) =>
                  rowData.fechaGeneracion
                    ? formatFecha(rowData.fechaGeneracion)
                    : "—"
                }
                style={{ width: "12rem" }}
              />
              <Column
                header="Aceptaciones"
                body={(rowData) => rowData._count?.aceptaciones ?? 0}
                style={{ width: "8rem", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
